import { SynopticLogoCompactIcon } from '@synoptic/ui-kit/icons/react/synoptic-logo-compact.tsx';
import { SynopticLogoIcon } from '@synoptic/ui-kit/icons/react/synoptic-logo.tsx';
import { useIsLaptop } from '@synoptic/ui-kit/responsive/hooks.ts';
import clsx from 'clsx';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import {
  headerLogoContent,
  logo,
  logoCompact,
  logoLinkWrapper,
  logoWrapperCollapsed,
} from './header-logo.css.ts';
import { useSidebarContext } from './sidebar-context.tsx';

export const HeaderLogo = () => {
  const isLaptop = useIsLaptop();

  const { isCollapsed } = useSidebarContext();

  const isCompact = !isLaptop || isCollapsed;

  return (
    <Link
      to={paths.home}
      className={clsx(logoLinkWrapper, {
        [logoWrapperCollapsed]: isCollapsed,
      })}
    >
      <div className={headerLogoContent}>
        {isCompact ? (
          <SynopticLogoCompactIcon
            className={logoCompact}
            height={29}
            width={21}
          />
        ) : (
          <>
            <SynopticLogoIcon className={logo} width={107} height={29} />
          </>
        )}
        {/*TODO: Replace <span>S</span> when it will be ready in Figma (now there is bad quality)*/}
      </div>
    </Link>
  );
};
